import { render, staticRenderFns } from "./IconDash.vue?vue&type=template&id=18db3926&scoped=true"
import script from "./IconDash.vue?vue&type=script&lang=js"
export * from "./IconDash.vue?vue&type=script&lang=js"
import style0 from "./IconDash.vue?vue&type=style&index=0&id=18db3926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db3926",
  null
  
)

export default component.exports